export default __webpack_public_path__ + "dist/media/Upload-file.6c6831d7.svg";